<template>
  <!-- 大图 -->
  <a class="infoflow-item big" target="_blank" :href="url" v-if="adStyle === 1" :data-space="material.speaceId" :data-material="material.id" >
    <div class="infoflow-title e-2" v-if="text">{{ text }}</div>

    <YorkbbsImage class="infoflow-cover__big" :src="imgSrc | webpFormat(650)" v-if="imgSrc"></YorkbbsImage>

    <div class="infoflow-extend">
      <span class="infoflow-adv">广告</span>
    </div>
  </a>
  <!-- 小图 -->
  <a class="infoflow-item small" target="_blank" :href="url" v-else-if="adStyle === 2" :data-space="material.speaceId" :data-material="material.id" >
    <div class="infoflow-others">
      <div class="infoflow-title e-2" v-if="text">{{ text }}</div>
      <div class="infoflow-extend">
        <span class="infoflow-adv">广告</span>
      </div>
    </div>

    <YorkbbsImage class="infoflow-cover__small" :src="imgSrc | webpFormat(150)" v-if="imgSrc"></YorkbbsImage>
  </a>
  <!-- 三图 -->
  <a class="infoflow-item multi" target="_blank" :href="url" v-else-if="adStyle === 3" :data-space="material.speaceId" :data-material="material.id" >
    <div class="infoflow-title e-2" v-if="text">{{ text }}</div>
    <div class="infoflow-images">
      <YorkbbsImage
        class="infoflow-image"
        v-for="(item, i) in pcImages"
        :key="i"
        :src="item | webpFormat(200)"
      ></YorkbbsImage>
    </div>
    <div class="infoflow-extend">
      <span class="infoflow-adv">广告</span>
    </div>
  </a>
  <!-- 纯文字 -->
  <a class="infoflow-item text" target="_blank" :href="url" v-else-if="adStyle === 4" :data-space="material.speaceId" :data-material="material.id" >
    <div class="infoflow-title e-2" :style="{ fontWeight: fontWeight ? 600 : 400, color: fontColor }" v-if="text">
      {{ text }}
    </div>
    <div class="infoflow-extend">
      <span class="infoflow-adv">广告</span>
    </div>
  </a>
  <!-- 代码广告 -->
  <iframe
    :data-space="material.speaceId" :data-material="material.id"
    :id="onlyTag"
    class="kjwt-item infoflow-item"
    frameborder="0"
    scrolling="no"
    :src="codeURL"
    v-else-if="adStyle === 5"
    :style="{ width: `100%`, height: `150px` }"
  ></iframe>
</template>
<script>
export default {
  name: 'ItemInfoflow',
  props: { data: Object },
  
  computed: {
    material() {
      return this.data.material || {};
    },
    // 信息流广告样式 1:大图 2:小图 3:3图 4:文字
    adStyle() {
      //pcAdStyle 为0的话，代表是旧的信息流广告，使用adStyle字段
      return this.material.pcAdStyle || this.material.adStyle;
    },
    imgSrc() {
      return this.pcImages[0];
    },
    pcImages() {
      return this.material.pcImages || [];
    },
    url() {
      return this.material.url;
    },
    // 标题，可选
    text() {
      return this.material.text;
    },
    // 标题颜色
    fontColor() {
      return this.material.fontColor;
    },
    // 标题是否加粗
    fontWeight() {
      return this.material.fontWeight;
    },
    textFiled1() {
      return this.material.textFiled1;
    },
    textFiled2() {
      return this.material.textFiled2;
    },
    textFiled3() {
      return this.material.textFiled3;
    },
    textFiled4() {
      return this.material.textFiled4;
    },
    // 代码广告地址
    codeURL() {
      return `/crm/inventory/code/${this.material.id}`;
    },
    onlyTag(){
      return `kjwt-item-${this.material.speaceId}-${this.material.id}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.infoflow-item {
  margin-bottom: 30px;
  display: block;
  &.small {
    display: flex;
    justify-content: space-between;
  }
}
.infoflow-title {
  font-size: 20px;
  line-height: 28px;
  &:hover {
    color: var(--primary-color);
  }
}
.infoflow-cover__big {
  height: 150px;
  margin-top: 12px;
  border-radius: 4px;
}
.infoflow-extend {
  margin-top: 12px;
}
.infoflow-adv {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
}
.infoflow-others {
  flex: 1;
  width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.infoflow-cover__small {
  width: 160px;
  height: 120px;
  border-radius: 4px;
  margin-left: 20px;
}
.infoflow-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0 25px;
  margin-top: 12px;
}
.infoflow-image {
  height: 150px;
  border-radius: 4px;
}
</style>
